"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GermanIcon = GermanIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function GermanIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    height: "600",
    viewBox: "0 0 5 3",
    width: "1000"
  }, props), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#000",
    height: "3",
    width: "5",
    x: "0",
    y: "0"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#D00",
    height: "2",
    width: "5",
    x: "0",
    y: "1"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#FFCE00",
    height: "1",
    width: "5",
    x: "0",
    y: "2"
  }));
}